import Tooltip from '@material-ui/core/Tooltip'

import ButtonNew from 'components/common/ButtonNew'
import { ReactSVG } from 'react-svg'
import * as SC from './styles'

export const VideoItem = ({ title, name, description, authors, video, onVideoClick, pdfLink, audioLink }) => {
  return (
    <SC.VideoContainer length={authors.length}>
      <div className="width-limiter">
        <SC.VideoColumn>
          <SC.IframeContainer>
            <iframe src={video} frameBorder="0" width="100%" height="100%" allowFullScreen />
            <div className="overlay" onClick={() => onVideoClick(video)} />
          </SC.IframeContainer>

          {(pdfLink || audioLink) && (
            <SC.ButtonsContainer>
              {pdfLink && (
                <SC.ButtonContainer>
                  <ButtonNew
                    href={pdfLink}
                    target="_blank"
                    variant="outlined"
                    iconLeft={<ReactSVG src={'/svgs/arrow-bottom.svg'} />}
                  >
                    Скачать PDF
                  </ButtonNew>
                </SC.ButtonContainer>
              )}
              {audioLink && (
                <SC.ButtonContainer>
                  <ButtonNew
                    href={audioLink}
                    target="_blank"
                    variant="outlined"
                    iconLeft={<ReactSVG src={'/svgs/arrow-bottom.svg'} />}
                  >
                    Скачать аудио
                  </ButtonNew>
                </SC.ButtonContainer>
              )}
            </SC.ButtonsContainer>
          )}
        </SC.VideoColumn>

        <div className="description__container">
          <span className="video-title">{title}</span>
          <h2 className="video-name">{name}</h2>
          <div className="author__list">
            {authors.map(author => (
              <div key={author.id} className="author__item">
                <img src="/svgs/slash.svg" />
                <SC.AuthorContainer length={authors.length}>
                  <span className="author-name">{author.name}</span>
                  {author.description.length < 28 || authors.length <= 3 ? (
                    <span className="author-description">{author.description}</span>
                  ) : (
                    <Tooltip title={author.description} placement="top">
                      <span className="author-description">{author.description}</span>
                    </Tooltip>
                  )}
                </SC.AuthorContainer>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SC.VideoContainer>
  )
}
